/* LGA drop countdown: what happens when the timer hits zero.
   - "plain":   the panel cracks and the pieces fall off the screen.
   - "stained": the panel turns into a stained-glass pane (colored pieces with
                lead lines), then the pieces fall.
   - "none":    no animation.
   Afterwards the "Fall Drop is live" message shows (if turned on), otherwise
   the section closes up.
   Shards are copies of the panel cut with clip-path and animated with the
   Web Animations API. They are fixed-position, ignore taps, and are removed
   once they have fallen.
   Visitors whose device asks for reduced motion get a gentler version: the
   cracks still appear, then the pieces fade out in place instead of falling.
   Test links (?shatter=...) always play the full version. */
(function () {
  var COLORS = [
    'rgba(243, 126, 194, 0.82)',
    'rgba(176, 104, 232, 0.80)',
    'rgba(255, 207, 112, 0.84)',
    'rgba(84, 196, 186, 0.78)',
    'rgba(138, 47, 120, 0.82)',
    'rgba(255, 244, 196, 0.86)',
    'rgba(120, 150, 240, 0.80)'
  ];

  function rand(a, b) {
    return a + Math.random() * (b - a);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Swap the countdown for the live message (or close the section up). */
  function endState(root) {
    /* Animate the panel itself (it carries the gradient), so nothing
       behind it shows through while it resizes. */
    var wrapper = root.closest('.shopify-section') || root;
    var count = root.querySelector('.lga-countdown__count');
    var live = root.querySelector('.lga-countdown__live');
    var oldH = root.offsetHeight;
    var aboveView = root.getBoundingClientRect().bottom < 0;

    if (count) count.style.display = 'none';

    if (live) {
      live.hidden = false;
      var newH = root.offsetHeight;
      if (aboveView) {
        window.scrollBy(0, newH - oldH);
      } else if (root.animate) {
        root.style.overflow = 'hidden';
        root.animate([{ height: oldH + 'px' }, { height: newH + 'px' }], {
          duration: 450,
          easing: 'ease-in-out'
        }).onfinish = function () {
          root.style.overflow = '';
        };
        live.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], {
          duration: 500,
          delay: 150,
          easing: 'ease-out',
          fill: 'backwards'
        });
      }
      return;
    }

    /* No live message: close the section up, then hide it. */
    if (aboveView || !root.animate) {
      if (aboveView) window.scrollBy(0, -oldH);
      wrapper.style.display = 'none';
      return;
    }
    root.style.overflow = 'hidden';
    root.animate([{ height: oldH + 'px' }, { height: '0px' }], {
      duration: 500,
      easing: 'ease-in-out',
      fill: 'forwards'
    }).onfinish = function () {
      wrapper.style.display = 'none';
    };
  }

  function polygonCss(points) {
    return 'polygon(' + points.map(function (p) {
      return p[0].toFixed(1) + 'px ' + p[1].toFixed(1) + 'px';
    }).join(', ') + ')';
  }

  /* Split the panel into shards around an impact point: three rings of
     pieces (small near the impact, larger toward the edges). */
  function makeShards(W, H) {
    var px = W * rand(0.4, 0.6);
    var py = H * rand(0.35, 0.65);
    var K = 8;
    var base = rand(0, Math.PI * 2);
    var angles = [];
    var r1 = [];
    var r2 = [];
    for (var i = 0; i < K; i++) {
      angles.push(base + (i + rand(-0.3, 0.3)) * (Math.PI * 2 / K));
      r1.push(rand(0.14, 0.24));
      r2.push(rand(0.4, 0.6));
    }
    function pt(a, r) {
      return [px + Math.cos(a) * r * W, py + Math.sin(a) * r * H];
    }
    var shards = [];
    for (var k = 0; k < K; k++) {
      var j = (k + 1) % K;
      var A0 = pt(angles[k], r1[k]);
      var A1 = pt(angles[j], r1[j]);
      var B0 = pt(angles[k], r2[k]);
      var B1 = pt(angles[j], r2[j]);
      var C0 = pt(angles[k], 3);
      var C1 = pt(angles[j], 3);
      shards.push({ pts: [[px, py], A0, A1], ring: 0 });
      shards.push({ pts: [A0, B0, B1, A1], ring: 1 });
      shards.push({ pts: [B0, C0, C1, B1], ring: 2 });
    }
    return { shards: shards, px: px, py: py };
  }

  function stripIds(node) {
    if (node.removeAttribute) {
      node.removeAttribute('id');
      node.removeAttribute('role');
      node.removeAttribute('aria-label');
    }
    var all = node.querySelectorAll ? node.querySelectorAll('[id],[role]') : [];
    for (var i = 0; i < all.length; i++) {
      all[i].removeAttribute('id');
      all[i].removeAttribute('role');
    }
  }

  function shatter(root, style, forceFull) {
    var count = root.querySelector('.lga-countdown__count');
    if (!count || style === 'none') {
      endState(root);
      return;
    }

    var rect = count.getBoundingClientRect();
    var onScreen = rect.bottom > 0 && rect.top < window.innerHeight;

    if (!onScreen || !count.animate) {
      endState(root);
      return;
    }

    var gentle = !forceFull && prefersReducedMotion();

    var stained = style === 'stained';
    var W = rect.width;
    var H = rect.height;
    var geo = makeShards(W, H);
    var svgNS = 'http://www.w3.org/2000/svg';

    var overlay = document.createElement('div');
    overlay.className = 'lga-shatter';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText =
      'position:fixed;left:' + rect.left + 'px;top:' + rect.top + 'px;width:' + W + 'px;height:' + H +
      'px;z-index:1000;pointer-events:none;';
    root.appendChild(overlay);
    /* The copies sit outside the centered wrapper, so carry its alignment
       over; otherwise the heading jumps left when the panel cracks. */
    overlay.style.textAlign = window.getComputedStyle(count).textAlign;

    var crackMs = stained ? 380 : 260;
    var holdMs = stained ? 650 : 260;
    var fallStart = crackMs + holdMs;
    var fallDist = window.innerHeight - rect.top + 120;
    var longest = 0;

    geo.shards.forEach(function (shard, idx) {
      var pts = shard.pts;
      var cx = 0;
      var cy = 0;
      pts.forEach(function (p) {
        cx += p[0];
        cy += p[1];
      });
      cx /= pts.length;
      cy /= pts.length;

      /* Skip shards that lie entirely outside the panel. */
      function allOut(test) {
        return pts.every(test);
      }
      if (
        allOut(function (p) { return p[0] <= 0; }) ||
        allOut(function (p) { return p[0] >= W; }) ||
        allOut(function (p) { return p[1] <= 0; }) ||
        allOut(function (p) { return p[1] >= H; })
      ) return;
      var ccx = Math.max(0, Math.min(W, cx));
      var ccy = Math.max(0, Math.min(H, cy));

      var el = document.createElement('div');
      var clip = polygonCss(pts);
      el.style.cssText =
        'position:absolute;left:0;top:0;width:' + W + 'px;height:' + H + 'px;overflow:hidden;' +
        'clip-path:' + clip + ';-webkit-clip-path:' + clip + ';' +
        'transform-origin:' + ccx.toFixed(1) + 'px ' + ccy.toFixed(1) + 'px;will-change:transform,opacity;';

      var copy = count.cloneNode(true);
      stripIds(copy);
      copy.style.margin = '0';
      el.appendChild(copy);

      var tint = document.createElement('div');
      tint.style.cssText =
        'position:absolute;inset:0;opacity:0;background:' +
        (stained
          ? COLORS[idx % COLORS.length]
          : 'linear-gradient(135deg, rgba(255,255,255,0.16), rgba(255,255,255,0) 45%)') +
        ';';
      el.appendChild(tint);

      var svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', W);
      svg.setAttribute('height', H);
      svg.style.cssText = 'position:absolute;left:0;top:0;overflow:visible;';
      var poly = document.createElementNS(svgNS, 'polygon');
      poly.setAttribute('points', pts.map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '));
      poly.setAttribute('fill', 'none');
      poly.setAttribute('stroke', stained ? '#262626' : 'rgba(255,255,255,0.95)');
      poly.setAttribute('stroke-width', stained ? '7' : '3');
      poly.setAttribute('stroke-linejoin', 'round');
      poly.setAttribute('pathLength', '1');
      poly.style.strokeDasharray = '1';
      poly.style.strokeDashoffset = '1';
      svg.appendChild(poly);
      el.appendChild(svg);

      overlay.appendChild(el);

      /* 1. Cracks (or lead lines) draw in, outward from the impact point. */
      var crackDelay = shard.ring * (crackMs / 4);
      poly.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], {
        duration: crackMs,
        delay: crackDelay,
        easing: 'ease-out',
        fill: 'forwards'
      });
      tint.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: crackMs,
        delay: crackDelay,
        easing: 'ease-out',
        fill: 'forwards'
      });

      /* 2. The piece pops loose, then falls with spin and drift. */
      var dx = cx - geo.px;
      var dy = cy - geo.py;
      var len = Math.hypot(dx, dy) || 1;
      var ux = dx / len;
      var uy = dy / len;
      var pop = rand(3, 9);
      var driftX = ux * rand(30, 110) + rand(-30, 30);
      var spin = rand(-140, 140);
      var dur = rand(1100, 1650);
      var delay = fallStart + shard.ring * rand(40, 110) + rand(0, 120);
      longest = Math.max(longest, delay + dur);

      if (gentle) {
        delay = fallStart + rand(0, 150);
        dur = 500;
        longest = Math.max(longest, delay + dur);
        el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: dur, delay: delay, fill: 'both' });
        return;
      }

      el.animate(
        [
          { transform: 'translate(0px, 0px) rotate(0deg)', opacity: 1, easing: 'ease-out' },
          { transform: 'translate(' + (ux * pop).toFixed(1) + 'px, ' + (uy * pop).toFixed(1) + 'px) rotate(0deg)', opacity: 1, offset: 0.08, easing: 'cubic-bezier(0.45, 0, 0.95, 0.55)' },
          { transform: 'translate(' + driftX.toFixed(1) + 'px, ' + fallDist.toFixed(0) + 'px) rotate(' + spin.toFixed(0) + 'deg)', opacity: 0.85, offset: 0.85 },
          { transform: 'translate(' + (driftX * 1.1).toFixed(1) + 'px, ' + (fallDist * 1.15).toFixed(0) + 'px) rotate(' + (spin * 1.1).toFixed(0) + 'deg)', opacity: 0 }
        ],
        { duration: dur, delay: delay, fill: 'both' }
      );
    });

    /* Hide the real panel; the copies sit exactly on top of it. */
    count.style.visibility = 'hidden';

    setTimeout(function () {
      endState(root);
    }, fallStart + 250);

    setTimeout(function () {
      overlay.remove();
    }, longest + 100);
  }

  window.LgaCountdownShatter = shatter;
})();
